export const data = {
	title: 'Conheça tudo, mas tudo mesmo do seu próximo carro:',
	list: [
		{
			opened: false,
			title: 'DISEÑO IMPACTANTE',
			slug: 'diseno',
			list: [
				{
					title: 'FAROS FULL LED',
					description: 'Rediseñados al mejor estilo italiano, los faros LED tienen el poder necesario para alumbrar cualquier camino durante la noche.<br/><br/><small>*Exclusivo de la versión Ranch y Volcano.</small>',
					poster: '/assets/images/imagens-accordion/design/accordion-desktop-design-1.jpg',
				},
				{
					title: 'NUEVA CABINA CON 5 LUGARES Y 4 PUERTAS',
					description: 'Por primera vez en la categoría, una pick up con 5 asientos y 4 puertas para que todos puedan viajar cómodamente.<br/><br/><small>*Disponible en todas las versiones de cabina doble.</small>',
					poster: '/assets/images/imagens-accordion/design/accordion-desktop-design-2.jpg',
				},
				{
					title: 'ESPACIO Y CONFORT',
					description: 'Además de la nueva cabina con espacio para toda la familia, el interior del automóvil se distingue por sus asientos de cuero y tela, con detalles de cuero en el volante.<br/><br/><small>*Tapizado en cuero exclusivo de la versión Volcano.</small>',
					poster: '/assets/images/imagens-accordion/design/accordion-desktop-design-3.jpg',
				},
				/*{
					title: 'VIDROS TRASEIROS ELÉTRICOS',
					description: 'Confortavelmente práticos para quem está no banco de trás subir e baixar os vidros em um só toque.<br/><br/><small>*Opcional na versão Endurance e de série nas demais versões.</small>',
					poster: '/assets/images/imagens-accordion/design/accordion-desktop-design-4.jpg',
				},*/
				
				{
					title: 'Llantas diamantadas de 15"',
					description: 'Robustez es un concepto clave en esta Fiat Strada, que ahora tiene llantas diamantadas de 15 ”.<br/><br/><small>*Disponible solo en la versión Ranch y Volcano.</small>',
					poster: '/assets/images/imagens-accordion/design/accordion-desktop-design-6.jpg',
				},

			],
		},
		{
			opened: false,
			title: 'FUERZA Y POTENCIA',
			slug: 'forca-e-potencia',
			list: [
				{
					title: 'CAJA DE CARGA',
					description: 'La mayor capacidad de carga de la categoría, con 1.354 litros y hasta 720 kg en la versión Endurance cabina plus. En las versiones cabina doble, el volumen de carga es de 844 litros y hasta 650 kg.<br/><small></small>',
					poster: '/assets/images/imagens-accordion/performance/accordion-desktop-potencia-1.jpg',
				},
				{
					title: 'EL MAYOR DESPEJE DE LA CATEGORÍA',
					description: 'Cuando la carga es pesada, la altura del suelo marca la diferencia: con hasta 214 mm, la Fiat Strada supera a sus competidores del segmento.<br/><small></small>',
					poster: '/assets/images/imagens-accordion/performance/accordion-desktop-potencia-2.jpg',
				},
				{
					title: 'SUSPENSIÓN MEJORADA',
					description: 'Mantuvimos la mecánica del sistema de suspensión, pero con una mejor configuración para que sea más resistente. También cuenta con suspensión delantera de brazos independientes para mayor confort y una trasera de eje rígido con resortes parabólicos para mayor resistencia de carga.',
					poster: '/assets/images/imagens-accordion/performance/accordion-desktop-potencia-3.jpg',
				},
				{
					title: 'CAJA DE CARGA MODULAR',
					description: 'Con 4 ganchos inferiores y hasta 6 ganchos superiores, un revestimiento preparado para altos impactos y un sistema de iluminación exclusivo, la caja de la Fiat Strada está pensada para ser personalizable para diferentes funciones, cargas y desafíos.',
					poster: '/assets/images/imagens-accordion/performance/accordion-desktop-potencia-4.jpg',
				},
				{
					title: 'MENOR CONSUMO DE COMBUSTIBLE',
					description: 'La autonomía ya no es un problema. El nuevo motor Firefly y FIRE garantizan un menor consumo de combustible sin pérdida de potencia ¡El mejor rendimiento de su segmento!',
					poster: '/assets/images/imagens-accordion/performance/accordion-desktop-potencia-5.jpg',
				},
				{
					title: 'E-LOCKER',
					description: 'El E-locker o control de tracción avanzado (TC +) es un sistema concebido para solucionar situaciones leves en terrenos resbaladizos. Al presionar la tecla TC+, el dispositivo transfiere más torque a la rueda con mayor agarre, haciendo que el vehículo supere obstáculos con mayor facilidad.<br/><small></small>',
					poster: '/assets/images/imagens-accordion/performance/accordion-desktop-potencia-6.jpg',
				},
			],
		},
		{
			opened: false,
			title: 'TECNOLOGIA',
			slug: 'tecnologia',
			list: [
				{
					title: 'CENTRAL MULTIMEDIA',
					description: 'Más tecnológica. La nueva central multimedia de 7“ se conecta a tu teléfono sin cables a través de Android Auto y CarPlay para que puedas usar aplicaciones como Spotify y Waze.<br/><br/><small>*Estándar en Volcano</small><br/><small>*Verificar compatibilidad con tu teléfono para la conexión inalámbrica</small>',
					poster: '/assets/images/imagens-accordion/tecnologia/accordion-desktop-tecnologia-1.jpg',
				},
				{
					title: 'COMANDOS AL VOLANTE',
					description: 'Además de tener los controles de radio y teléfono a tu alcance, también cuenta con un acabado de cuero extremadamente elegante.<br/><br/><small>*Comandos de serie en todas las versiones.</small>',
					poster: '/assets/images/imagens-accordion/tecnologia/accordion-desktop-tecnologia-2.jpg',
				},
				{
					title: 'AIRE ACONDICIONADO Y MUCHO ESPACIO',
					description: 'Además de ser espaciosa, tanto la versión Ranch como Volcano vienen con Climatizador automático. Por supuesto todas las versiones están equipadas con aire acondicionado.',
					poster: '/assets/images/imagens-accordion/tecnologia/accordion-desktop-tecnologia-3.jpg',
				},
				/*{
					title: 'USB E RÁDIO',
					description: 'Indispensável para deixar o dia mais leve, o rádio possui conexão Bluetooth e entrada USB.<br/><br/><small>*Disponível de série na versão Freedom e opcional na versão Endurance.</small>',
					poster: '/assets/images/imagens-accordion/tecnologia/accordion-desktop-tecnologia-4.jpg',
				},*/
				{
					title: 'PANEL DE TABLERO TFT DE 3,5’’',
					description: 'Personalizá a tu preferencia la información que aparece en el panel.<br/><br/><small></small>',
					poster: '/assets/images/imagens-accordion/tecnologia/accordion-desktop-tecnologia-4.jpg',
				},
				{
					title: 'NUEVA TECNOLOGÍA EN EL PORTÓN TRASERO',
					description: 'La FIAT Strada tiene el portón trasero tan liviano	que podés abrirla y cerrarla con una sola mano. Además de ser ligero, es súper resistente; soporta hasta 400 kg en la parte superior de la tapa abierta.<br/><br/><small>*De serie en todas las versiones.</small>',
					poster: '/assets/images/imagens-accordion/tecnologia/accordion-desktop-tecnologia-5.jpg',
				},

			],
		},
		{
			opened: false,
			title: 'SEGURIDAD',
			slug: 'seguranca',
			list: [
				{
					title: 'AIRBAGS LATERALES',
					description: 'Ahora, además de los 2 airbags frontales, los pasajeros se encuentran protegidos por los airbags laterales.<br/><br/><small>*De serie en las versiones cabina doble.</small>',
					poster: '/assets/images/imagens-accordion/seguranca/accordion-desktop-seguranca-4.jpg',
				},
				{
					title: 'CÁMARA DE ESTACIONAMIENTO CON SENSORES',
					description: 'Sensor de estacionamento sonoro y cámara de reversa con guías dinámicas, para ayudarte siempre que tengas que ir en reversa.<br/><br/><small>* Equipamiento de serie en versión Ranch y Volcano. </small>',
					poster: '/assets/images/imagens-accordion/seguranca/accordion-desktop-seguranca-1.jpg',
				},
				{
					title: 'CONTROL DE ESTABILIDAD',
					description: 'El control de estabilidad te ayuda a mantener la dirección en curvas o derivas pronunciadas. <br/><br/><small>*De serie en todas las versiones.</small>',
					poster: '/assets/images/imagens-accordion/seguranca/accordion-desktop-seguranca-3.jpg',
				},
				{
					title: 'ASISTENCIA AL ARRANQUE EN PENDIENTE',
					description: 'Cuando la carga es pesada, toda ayuda es bienvenida. Por esta razón, la Fiat Strada tiene el sistema Hill Holder, que mantiene el automóvil parado y ayuda en los arranques cuesta arriba.<br/><br/><small>*De serie en todas las versiones.</small>',
					poster: '/assets/images/imagens-accordion/seguranca/accordion-desktop-seguranca-2.jpg',
				},
				{
					title: 'ISOFIX',
					description: 'Traba de uso práctico y seguro para fijar la silla del bebé en el asiento trasero de tu Fiat Strada.<br/><br/><small>*En versiones de cabina doble.</small>',
					poster: '/assets/images/imagens-accordion/seguranca/accordion-desktop-seguranca-5.jpg',
				},
				{
					title: 'KIT DE SEGURIDAD',
					description: 'Este vehículo es entregado en el concesionario oficial con un kit de seguridad y cubre alfombras homologadas.',
					poster: '/assets/images/imagens-accordion/seguranca/accordion-desktop-seguranca-6.jpg',
				},
			],
		},
		{
			opened: false,
			title: 'ACCESORIOS',
			slug: 'acessorios',
			list: [
				{
					title: 'DIVISOR DE CAJA',
					description: 'CÓD. 50290170',
					poster: '/assets/images/imagens-accordion/acessorios/accordion-desktop-acessorios-1.jpg',
				},
				{
					title: 'ENGANCHE REMOLQUE',
					description: 'CÓD. 50928965',
					poster: '/assets/images/imagens-accordion/acessorios/accordion-desktop-acessorios-3.jpg',
				},
				{
					title: 'SOPORTE DE BICICLETA',
					description: 'CÓD. 50928972',
					poster: '/assets/images/imagens-accordion/acessorios/accordion-desktop-acessorios-4.jpg',
				},
				{
					title: 'JUEGO DE TORNILLOS ANTIROBOS PARA RUEDA',
					description: 'CÓD. 50902050<br/>Tornillos de seguridad para ruedas con llantas de aleación, el juego incluye 4 tornillos y una llave de seguridad',
					poster: '/assets/images/imagens-accordion/acessorios/accordion-desktop-acessorios-5.jpg',
				},
				{
					title: 'TORNILLO ANTIROBOS PARA RUEDA DE AUXILIO',
					description: 'CÓD. 50927856',
					poster: '/assets/images/imagens-accordion/acessorios/accordion-desktop-acessorios-6.jpg',
				},
				{
					title: 'RED ELÁSTICA DE ASIENTO DELANTERO',
					description: 'CÓD. 50927606<br/>Es una red diseñada para organizar y evitar el movimiento de objetos en el asiento.',
					poster: '/assets/images/imagens-accordion/acessorios/accordion-desktop-acessorios-7.jpg',
				},
				{
					title: 'RED ELÁSTICA VERTICAL',
					description: 'CÓD. 7086178',
					poster: '/assets/images/imagens-accordion/acessorios/accordion-desktop-acessorios-8.jpg',
				},
			],
		},

	/* 	{
			opened: false,
			title: 'SERVICIOS',
			slug: 'servicos',
			list: [
				{
					title: 'MOPAR VEHICLE PROTECTION',
					description: 'Los mejores servicios y oportunidades para tu nueva Fiat Strada.',
					poster: '/assets/images/imagens-accordion/servicos/accordion-desktop-servicos-4.jpg',
					button: 'Más Información',
					href: 'https://servicios.fiat.com.ar/',
					className:'Menu-asideAnchorLinkbtn',
					target: '_blank',
				},

				{
					title: 'GARANTIA EXTENDIDA',
					description: 'Su nueva Fiat Strada cuenta con 3	años de garantía de fábrica, pero puede extenderla por 12 0 24 meses más.',
					poster: '/assets/images/imagens-accordion/servicos/accordion-desktop-servicos-2.jpg',
					button: 'Consultá en tu concesionario.',
					href: 'https://servicios.fiat.com.ar/',
					className:'Menu-asideAnchorLinkbtn',
					target: '_blank',
				},
				{
					title: 'MOPAR ASSISTANCE',
					description: 'El Vehículo cuenta con cobertura durante el primer año de uso, en	cualquier lugar del la republica argentina y en países limítrofes.',
					poster: '/assets/images/imagens-accordion/servicos/accordion-desktop-servicos-3.jpg',
					button: 'Más Información',
					href: 'https://servicios.fiat.com.ar/',
					className:'Menu-asideAnchorLinkbtn',
					target: '_blank',
				},
			],
		}, */
	],
};
/* 				{
					title: 'SERVICIO ANTICIPADO MOPAR',
					description: 'Packs con opciones de dos a cuatro revisiones incluidas.<br>Mantenimiento de la garantía de fábrica por realizar las revisiones en la Red Fiat.<br> Precios fijos y atención en cualquier punto asistencial de la Red Fiat en	Argentina.<br>Posibilidad de financiación.<br>Mano de obra calificada y repuestos originales Mopar con garantía de Fábrica.<br>',
					poster: '/assets/images/imagens-accordion/servicos/accordion-desktop-servicos-1.jpg',
					button: 'Consultá en tu concesionario.',
					href: 'https://servicios.fiat.com.ar/',
					className:'Menu-asideAnchorLinkbtn',
					target: '_blank',
				}, */
export default data;
